<div class="sin-resultados">
    <neo-icono [iconoClase]="'icon-60 icon-ibm--information'"></neo-icono>
    <p class="text-h3 mt-10">{{texto}}</p>
</div>
